export const ITEM_DRAWER_WIDTH = 380;

export const SIDEBAR_WIDTH = 340;
